const SELECTED = 'select2--has-option-selected';

function initSelects () {
  const $selects = $('[data-select-two]');
  $selects.select2();
  $selects.each((_, select) => {
    const $select = $(select);
    if ($select.val()) $select.siblings('.select2').addClass(SELECTED);
  });
}

function attachSelectContext () {
  $(window).on('turbolinks:load', initSelects);
  $(document).on('select2:select', 'select', function () {
    $(this).siblings('.select2').addClass(SELECTED);
  });
  $(document).on('select2:unselect', 'select', function () {
    $(this).siblings('.select2').removeClass(SELECTED);
  });

  initSelects();
}

export default attachSelectContext;
